type Props = {
  color?: string;
};

export default function CalendarSquare({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="2" fill={color} />
    </svg>
  );
}
